//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadPeriods from "@/pages/UserSettings/BackofficeSettings/components/UploadPeriods.vue";


export default {
  name: "UserSettings",
  components: {
      UploadPeriods
  },
  mounted: function () {},
  data: () => ({
    selectedOption: {
      value: "upload_periods",
      label: "Períodos Carregamento",
    }
  })
};
